<div class="container-fluid">
  <!-- Page Title -->
  <app-pagetitle
    title="Customer Switcher"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>

  <!-- Search Bar -->
  <div class="row mb-4">
    <div class="col-md-6 col-lg-4">
      <div class="search-wrapper position-relative">
        <i class="ri-search-line search-icon"></i>
        <input
          type="text"
          class="form-control search-input"
          placeholder="Search by customer name, ID, or phone..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterCustomers()"
        />
      </div>
    </div>
  </div>

  <!-- Customer Cards Grid -->
  <div class="row" *ngIf="filteredCustomers.length > 0; else noCustomers">
    <div
      class="col-md-6 col-lg-4 mb-4"
      *ngFor="let item of filteredCustomers; let i = index"
    >
      <div class="customer-card">
        <!-- Card Badge -->
        <div class="card-badge">Card #{{ i + 1 }}</div>

        <!-- Card Body -->
        <div class="customer-card-body">
          <div class="customer-header mb-3">
            <h4
              class="customer-name text-dark m-0 text-truncate"
              [title]="item.user.customerName"
            >
              {{ item.user.customerName }}
            </h4>
            <span class="customer-id-badge mt-1">
              ID: {{ item.user.custId }}
            </span>
          </div>

          <div class="customer-details">
            <div class="detail-item d-flex align-items-center mb-2">
              <i class="ri-mail-line detail-icon text-info me-2"></i>
              <span
                class="detail-value text-muted text-truncate"
                [title]="item.user.email"
              >
                {{ item.user.email }}
              </span>
            </div>
            <div class="detail-item d-flex align-items-center mb-2">
              <i class="ri-phone-line detail-icon text-success me-2"></i>
              <span class="detail-value text-muted text-truncate">
                {{ item.user.mobileNumber || "N/A" }}
              </span>
            </div>
            <div class="detail-item d-flex align-items-center">
              <i class="ri-map-pin-time-line detail-icon text-warning me-2"></i>
              <span class="detail-value text-muted text-truncate">
                {{ item.user.timeZone || "Asia/Kolkata" }}
              </span>
            </div>
          </div>

          <!-- Switch Button -->
          <div class="card-action mt-4">
            <button
              class="btn btn-switch btn-block py-2 font-weight-bold"
              (click)="selectCustomer(item)"
            >
              <i class="ri-external-link-line me-1"></i> Switch to Portal
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No Customers Fallback -->
  <ng-template #noCustomers>
    <div class="text-center py-5 w-100">
      <div
        class="no-customers-icon-wrapper mb-3 bg-light d-inline-flex p-3 rounded-circle"
      >
        <i class="ri-user-search-line display-4 text-muted"></i>
      </div>
      <h4 class="text-dark">No Customers Found</h4>
      <p class="text-muted">
        We couldn't find any customers matching "{{ searchTerm }}".
      </p>
    </div>
  </ng-template>
</div>
